// src/components/CommonESignWrapper.tsx

import React from 'react';
import {
  ESignValidation,
  FreyrComponentLibraryProvider,
} from '@freyr/freyr-react-common-components';
import { GET_API } from '../api/apiFunctions';

interface CommonESignWrapperProps {
  token: string;
  tenantID: string;
  domain: string;
  userName: string;
  currentLanguage?: string;
  isEsignaturePopupDisplay: boolean;
  progressStateButtonsignText?: string;
  handleCloseESign: () => void;
  handleSubmitEsign: () => void;
  handleSuccessESign?: () => void;
  handleErrorESign?: () => void;
}

const CommonESignWrapper: React.FC<CommonESignWrapperProps> = ({
  token,
  tenantID,
  domain,
  userName,
  currentLanguage = '',
  isEsignaturePopupDisplay,
  progressStateButtonsignText = '',
  handleCloseESign,
  handleSubmitEsign,
  handleSuccessESign,
  handleErrorESign,
}) => {
  return (
    <>
      {/* <style>
        {`
          .MuiDialog-paper { 
            overflow: hidden !important; 
            max-height: 90vh !important;
          }
          .MuiDialogContent-root { 
            overflow: auto !important;
            max-height: calc(90vh - 120px) !important;
          }
        `}
      </style> */}
      <div className=''>
      <FreyrComponentLibraryProvider
      token={token}
      language={currentLanguage}
      tenant={tenantID}
      domain={domain}
      domainName={domain}
      useEmail={userName}
      envVars={{URF_PREFIX:GET_API.slice(0,-1)}}
    >
      <ESignValidation
        progressStateButtonsignText={progressStateButtonsignText}
        isOpenEsigntrue={isEsignaturePopupDisplay}
        onCancel={handleCloseESign}
        onDialogSubmit={handleSubmitEsign}
        handleEsignatureSuccess={handleSuccessESign}
        handleEsignatureError={handleErrorESign}
      />
    </FreyrComponentLibraryProvider>
      </div>
    </>
  );
};

export default CommonESignWrapper;